




































































































import Vue from 'vue';
import _ from 'lodash';
import * as bibistore from '../modules/bibistore';

import { EventBus, graph} from '../main';

export default Vue.extend({
  name: 'metadataViewer',
  props: ['doi'],
  data(){ return {
    nodelist: graph.state.nodelist,
    graph: {nodes:[], links:[]},
    metadata: {},
  }},
  computed: {
    isInGraph(){
      return  _.includes(this.nodelist, this.doi)
    },
    reference(){
      if( !this.metadata.reference ){
        return null;
      } else {
        return this.parseRefField( this.metadata.reference )
      }
    },
    hasMissingRefs(){
      return this.reference.some( (parsedref) => !parsedref.instore );
    },
    // node(){
    //   return this.graph.nodes.filter( (node) => node.doi.toLowerCase() === this.doi.toLowerCase() )[0]
    // },
    citedby(){
      return this.metadata.citedby.map( (doi)=> ({
        key: bibistore.get([doi])[0].key,
        doi: doi,
        ingraph: this.isDoiInGraph(doi),
      }))
    },
  },
  created (){
    console.log('hello meta', this.doi)
    this.metadata = bibistore.get( [this.doi] )[0];
  },
  beforeUpdate (){
    this.metadata = bibistore.get( [this.doi] )[0];
  },
  methods: {
    parseRefField( reflist ){
      /* Analyse the reference information provided by CrossRef */

      const doilist = reflist.filter( (refinfo) => refinfo.DOI )
                             .map( (refinfo) => refinfo.DOI )

      const parsedreflist = doilist.map( (doi) => {
        const metadata = bibistore.get([doi])[0];
        const key = metadata? metadata.key : doi;

        return {
          doi: doi,
          key: key,
          instore: !!metadata,
          ingraph: this.isDoiInGraph(doi),
          citedbycount: metadata? metadata.citedbycount : '#',
        }
      })
      return parsedreflist
    },
    isDoiInGraph(doi){
      return this.nodelist.filter( (nodedoi) => nodedoi.toLowerCase() === doi.toLowerCase() ).length == 1
    },
    addToGraph(doi){ graph.addToGraph(doi);  },
    removeFromGraph(doi){ graph.removeFromGraph(doi); },
    closepanel(){
      EventBus.$emit('closemetadata')
    },
    showmetadata (doi){
      EventBus.$emit('showmetadata', doi);
    },
    queryMissingRefs(){

      var doi_refs = this.metadata.referenceWithDOI
      doi_refs = doi_refs.filter( (doi) => !bibistore.get([doi])[0] )

      // query missing
      bibistore.query(doi_refs).then( (metadata) => {
        //this.alldoi = bibistore.alldoi();
        console.log('refs added')
        this.metadata =  Object.assign({}, bibistore.get( [this.doi] )[0]);
        EventBus.$emit('storageUpdate')
      })
    },
  },
});



